import { LineaAdquirente } from './../../../models/LineaAdquirente.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccesoService } from 'app/services/acceso/acceso.service';
import { LocalService } from 'app/services/storage/localService';
import { SessionStorageService } from 'app/services/storage/sessionStorage.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { filter, pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LineaAdquirenteService {
  readonly urlBase = environment.rutaBase;
  message: Observable<any>;
  idEmpresa_Factor: any;
  header: HttpHeaders;

  constructor(
    private http: HttpClient,
    private accesoService: AccesoService,
    private sessionStorageService: SessionStorageService,
    private localService: LocalService
  ) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage();
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
    if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
    }
  }

  obtenerListaLineasAdquirente() {
    let headers: HttpHeaders = this.header;
    return this.http.get(`${this.urlBase}/lineaAdquirente?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }
  obtenerListaLineasAdquirenteById(idEmpresa: any,idMoneda : any) {
    let headers: HttpHeaders = this.header;
    return this.http.get(`${this.urlBase}/lineaAdquirente?idEmpresa=${idEmpresa}&idMoneda=${idMoneda}&idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }
  crearLineaAdquirente(bodyLineaAdquirente: any) {
    let headers: HttpHeaders = this.header;
    return this.http.post(`${this.urlBase}/lineaAdquirente?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyLineaAdquirente, { headers });
  }

  evaluarLineaAdquirente(idLineaAdquirente: number, bodyLineaAdquirente: any) {
    let headers: HttpHeaders = this.header;
    return this.http.put(`${this.urlBase}/lineaAdquirenteEvaluacion/${idLineaAdquirente}?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyLineaAdquirente, { headers });
  }

  cambiarDeEstadoLineaAdquirente(idLineaAdquirente: number, bodyLineaAdquirente: any) {
    let headers: HttpHeaders = this.header;
    return this.http.put(`${this.urlBase}/lineaAdquirente/${idLineaAdquirente}?idEmpresa_Factor=${this.idEmpresa_Factor}`, bodyLineaAdquirente, { headers });
  }
}
